<template>
  <aside class="control-sidebar control-sidebar-dark" :class="{'control-sidebar-open': mostrar}">
    <form @submit.prevent="guardar" v-if="selectedItem && atributosForm">
      <div class="form-group" v-for="attr in atributosForm">
        <template v-if="attr.name === 'codigo_proyecto'">
          <label :for="attr.name">{{ attr.name | labelCase }}</label>
          <input v-if="selectedItem.codigo_proyecto" type="text" class="form-control" name="attr.name" :disabled="true" v-model="selectedItem.codigo_proyecto">
          <select v-else class="form-control" v-model="proyecto" :name="attr.name" @change="cambiarProyecto" v-validate="'required'" data-vv-validate-on="none" :disabled="!editar">
            <option :value="null">-- Seleccione --</option>
            <option v-for="proyecto in $store.state.apiData.proyectos" :value="proyecto">{{ proyecto.codigo_proyecto }}</option>
          </select>

          <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
        </template>
        <template v-else-if="attr.name === 'cliente_empresa'">
          <label :for="attr.name">{{ attr.name | labelCase }}</label>
          <input type="text" :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>
          <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>  
        </template>
        <template v-else-if="attr.name === 'nombre_proyecto'">
          <label :for="attr.name">{{ attr.name | labelCase }}</label>
          <input type="text" :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>  
          <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
        </template>
        <template v-else-if="attr.name === 'observaciones_descripcion'">
          <label :for="attr.name">{{ attr.name | labelCase }}</label>
          <textarea :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" v-validate="require_if_obs" data-vv-validate-on="none" :disabled="!editar || !selectedItem.observaciones"></textarea>
          <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
        </template>
        <template v-else-if="attr.name === 'usuario'">
          <label :for="attr.name">{{ attr.name | labelCase }}</label>
          <input type="text" :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" :disabled="true" v-validate="'required'" data-vv-validate-on="none"/>  
          <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
        </template>        
        <template v-else>
          <template v-if="attr.params.type === 'string'">
            <label :for="attr.name">{{ attr.name | labelCase }}</label>
            <input type="text" :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" :disabled="!editar"/>
            <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
          </template>
          <template v-if="attr.params.type === 'date'">
            <label :for="attr.name">{{ attr.name | labelCase }}</label>
            <datepicker :name="attr.name" v-model="selectedItem[attr.name]" :input-class="'form-control'" :language="es" :format="'dd MMMM'" :disabled="!editar"></datepicker>
          </template>
          <template v-if="attr.params.type === 'boolean' && attr.name !== 'archivado'">
            <label class="control-sidebar-subheading">
              {{ attr.name | labelCase }}
              <input type="checkbox" :name="attr.name" v-model="selectedItem[attr.name]" :value="attr.params.default" class="pull-right" :disabled="!editar">
            </label>
          </template>
          <template v-if="attr.params.type === 'text'">
            <label :for="attr.name">{{ attr.name | labelCase }}</label>
            <textarea :name="attr.name" v-model="selectedItem[attr.name]" class="form-control" :disabled="!editar"></textarea>
          </template>
          <template v-if="attr.params.type === 'integer'">
            <label :for="attr.name">{{ attr.name | labelCase }}</label>
            <input type="number" :name="attr.name" v-model="selectedItem[attr.name]" min="0" class="form-control" :disabled="!editar"/>
            <span class="text-danger" v-show="errors.first(attr.name)">{{ errors.first(attr.name) }}</span>
          </template>
        </template>
      </div>
      <button class="btn btn-block bg-red" v-if="editar">
        Guardar
        <div v-if="guardando" class="loading"></div>
      </button>
      <button type="button" class="btn btn-block btn-default" @click="cerrar()">
        <i class="fa fa-close"></i> Cerrar
      </button>          
    </form>
  </aside>  
</template>
<script>
import { mapGetters } from 'vuex'
import api from '../../../api'
import {labelCase} from '../../../filters/string'
import db from '../../../core/pouchdb'
import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
// import moment from 'moment'
export default {
  name: 'AMParteDiario',
  components: {
    Datepicker
  },
  filters: {
    labelCase
  },
  props: {
    atributosForm: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    mostrar: {
      type: Boolean,
      default () {
        return false
      }
    },
    editar: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      es: es,
      selectedItem: this.item || {},
      errores: '',
      guardando: false,
      proyecto: null
    }
  },
  computed: {
    ...mapGetters([
      'getProyectoPorCodigo'
    ]),
    require_if_obs () {
      return this.selectedItem.observaciones ? 'required' : ''
    }
  },
  mounted () {
  },
  methods: {
    guardar () {
      let vm = this
      this.$validator.validate().then(result => {
        if (result) {
          let item = _.cloneDeep(this.selectedItem)
          vm.errores = ''
          vm.guardando = true
          if (vm.$store.state.online) {
            api.savePartesDiarios(item).then(data => {
              vm.guardando = false
              vm.cerrar(data)
            }, error => {
              vm.guardando = false
              vm.errores = error.message
            })
          } else {
            db.save(item, 'parte_diario', item.id ? 'edit' : 'create').then(function (response) {
              if (typeof item.fecha !== 'string') {
                item.fecha = item.fecha.toISOString()
              }
              item._rev = response.rev
              vm.guardando = false
              vm.cerrar(item)
            }).catch(function (error) {
              vm.guardando = false
              vm.errores = error.message
              console.debug(error)
            })
          }
        }
      })
    },
    cerrar (item) {
      this.errores = ''
      this.$emit('am-partes:cerrar', (item || null))
    },
    cambiarProyecto () {
      if (this.proyecto) {
        this.selectedItem.codigo_proyecto = this.proyecto.codigo_proyecto
        this.selectedItem.cliente_empresa = this.proyecto.cliente_empresa
        this.selectedItem.nombre_proyecto = this.proyecto.nombre_proyecto
      } else {
        this.selectedItem.codigo_proyecto = null
        this.selectedItem.cliente_empresa = null
        this.selectedItem.nombre_proyecto = null
      }
    }
  },
  watch: {
    item: function (a, b) {
      if (a) {
        this.selectedItem = a
        this.proyecto = this.getProyectoPorCodigo(a.codigo_proyecto)
        this.cambiarProyecto()
      }
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/partes-diarios/AMParteDiario.vue